import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';

export default function SectionA() {
    const { useRouter, Link } = useGlobal();
    const { t } = useLang('powerstream.detail.firstKv');
    const { locale } = useRouter();
    const LINK_MAP: any = {
        eu: 'https://energy.ecoflow.com/eu/powerstream-cooperation',
        de: 'https://energy.ecoflow.com/de/powerstream-cooperation',
        fr: '/powerstream-cooperation',
        it: '/powerstream-cooperation',
        es: '/powerstream-cooperation',
    };

    return (
        <div className={styles.firstKv}>
            <div className="section-box">
                <div className="kv-box">
                    <div className="kv-bg">
                        {locale === 'fr' ? (
                            <NextImage src={require('@publicLocal/power-stream/detail/pc/kv_fr.jpg')} alt={t('title')} />
                        ) : (
                            <NextImage
                                src={require('@publicLocal/power-stream/detail/pc/kv.jpg')}
                                webpSrc={require('@publicLocal/power-stream/detail/pc/kv.webp')}
                                alt={t('title')}
                            />
                        )}
                    </div>
                    <div className="kv-text">
                        <p className="title">{t('title')}</p>
                        <p className="desc">{t('desc')}</p>
                    </div>
                    {!['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale) && (
                        <Link href={LINK_MAP[locale] || ''} className="icon">
                            <NextImage src={require(`@publicLocal/power-stream/detail/icon_pc_${locale}.png`)} alt="EcoFlow PowerStream" />
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
